export default __webpack_public_path__ + "static/top-b6dcabbc7f1710c1a1ac2282948ff890.png";